import { render } from "./BaseLogField.vue?vue&type=template&id=83db0886"
import script from "./BaseLogField.vue?vue&type=script&lang=js"
export * from "./BaseLogField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__